import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusinessCardQueryParams } from '@warema/shared/company-search/models';
import { WorkflowOrigin } from '@warema/shared/models';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivityDataService } from '../activity/services/activity-data.service';
import { ProductCategoryDataService } from '../product-category/services/product-category-data.service';
import { SearchDataService } from '../search/services/search-data.service';

@Injectable({
    providedIn: 'root',
})
export class BusinessCardUtilityService {
    public readonly productCategoryDataService = inject(ProductCategoryDataService);
    public readonly searchDataService = inject(SearchDataService);
    private readonly _activityDataServie = inject(ActivityDataService);
    private readonly _activatedRoute = inject(ActivatedRoute);

    public generateBusinessCardQueryParams(): Observable<BusinessCardQueryParams> {
        return combineLatest([
            this.searchDataService.latestSearchedCoordinates$,
            this.productCategoryDataService.selectedSubProductCategoriesIds$,
            this._activityDataServie.selectedActivity$,
            this._activatedRoute.queryParams,
        ]).pipe(
            map(([latestSearchedCoordinates, productCategories, activity, queryParams]): BusinessCardQueryParams => {
                const workflowOrigin = queryParams['origin'] as WorkflowOrigin;
                return {
                    productSubCategoriesIds: productCategories,
                    activity,
                    searchAddress: latestSearchedCoordinates.address,
                    origin: workflowOrigin ?? WorkflowOrigin.WaremaPlusDefault,
                };
            }),
        );
    }
}
